import { useContext, useState } from 'react';

import createToast from 'components/Toast/Toast';
import {
  getAddressExportFileUrl,
} from 'URLs';

import { api } from 'utility';
import { saveAs } from 'file-saver';
import { enifyDateTime, jDateNow } from 'utility/util';
import { SaveOnPodSpaceDialogContex, DispatchSaveOnPodSpaceDialogContext } from 'providers';

const AUTO_LOGIN_TO_POD_SPACE_URL = getAddressExportFileUrl();

function useSaveOnPodSpace() {
  const { isOpenDialog, isAutoLoginLoading, isForceSaveLoading, onConfirm } = useContext(
    SaveOnPodSpaceDialogContex,
  );
  const dispatch = useContext(DispatchSaveOnPodSpaceDialogContext);

  const openDialog = () => dispatch({ type: 'OPEN_DIALOG' });
  const closeDialog = () => dispatch({ type: 'CLOSE_DIALOG' });
  const startForceSave = () => dispatch({ type: 'FORCE_SAVE_STARTED' });
  const finishForceSave = () => dispatch({ type: 'FORCE_SAVE_FINISHED' });

  const setOnConfirm = (onConfirm) => dispatch({ type: 'SET_ON_CONFIRM', payload: onConfirm });

  const autoLoginToPodSpace = async () => {
    try {
      dispatch({ type: 'AUTO_LOGIN_STARTED' });
      const res = await api.get(AUTO_LOGIN_TO_POD_SPACE_URL);
      window.open(res.data.result);
    } catch (error) {
    } finally {
      dispatch({ type: 'AUTO_LOGIN_FINISHED' });
    }
  };
  return {
    isOpenDialog,
    isAutoLoginLoading,
    isForceSaveLoading,
    onConfirm,
    openDialog,
    closeDialog,
    startForceSave,
    finishForceSave,
    setOnConfirm,
    autoLoginToPodSpace,
  };
}

export default function useExportFile({ url, filename }) {
  const [isExporting, setIsExporting] = useState(false);
  const { openDialog, startForceSave, finishForceSave, setOnConfirm } = useSaveOnPodSpace();
  const getNormalizedParams = (params) => {
    const tempParams = { ...params };
    tempParams?.hasOwnProperty?.('page') && delete tempParams.page;
    tempParams?.hasOwnProperty?.('size') && delete tempParams.size;
    return tempParams;
  };

  const downloadFile = async (extension, postParams, incomingParams) => {
    const modifiedUrl = `${url}/${extension}`;
    const preferedExtension = extension === 'xls' ? 'xlsx' : extension;
    const savedFileName = `${filename || 'report'}-${enifyDateTime(
      jDateNow({ format: 'jYYYY/jMM/jDD' }),
    )}.${preferedExtension}`;

    const ctype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    const params = incomingParams ? { ...incomingParams } : {};
    delete params?.page;
    delete params?.size;

    const forceSave = async () => {
      startForceSave();
      try {
        await api.post(modifiedUrl, postParams, {
          params: { ...getNormalizedParams(params), forceSave: true },
        });
      } catch (error) {
      } finally {
        finishForceSave();
      }
    };
    setOnConfirm(forceSave);

    // start download
    setIsExporting(true);
    const headers = {
      idToken: 'true',
    };
    try {
      const res = await api.post(modifiedUrl, postParams, {
        responseType: 'blob',
        params: { ...getNormalizedParams(params), forceSave: false },
        headers
      });
      try {
        const d = await res.data.text();

        if (d.includes('"code":137')) {
          openDialog();
          return;
        }
        if (d.includes('"status":5') || d.includes('"status":4')) {
          const resObj = JSON.parse(d);


          return Promise.reject(resObj?.message);
        }

        if (extension === 'csv') {
          const reader = new FileReader();
          reader.readAsText(
            new Blob([res.data], {
              type: ctype,
            }),
          );
          reader.onloadend = function () {
            const csvString = reader.result;
            const universalBOM = '\uFEFF';
            const a = window.document.createElement('a');
            a.setAttribute(
              'href',
              `data:text/csv; charset=utf-8,${encodeURIComponent(universalBOM + csvString)}`,
            );
            a.setAttribute('download', savedFileName);
            window.document.body.appendChild(a);
            a.click();
          };
        } else saveAs(new Blob([res.data], { type: ctype }), savedFileName);
      } catch (e) {
      }
      return res;
    } catch (error) {
      try {
        const dataError = await error.response?.data?.text?.(); // data is blob so it should convert to text
        if (dataError.includes('"code":137')) {
          openDialog();
          return;
        }
        const message = JSON.parse(dataError)?.message ? JSON.parse(dataError)?.message : 'خطا در انجام عملیات';

        createToast('خطا', message, 'danger');

      } catch (e) {
      }
    } finally {
      setIsExporting(false);
    }
  };

  return {
    isExporting,
    downloadFile,
  };
}

export { useExportFile, useSaveOnPodSpace };
